var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { PubInputField } from 'components/Shared/PubInputField/PubInputField';
import { B2B_CHANNEL, GSA_CHANNEL, channelArray, REQUEST_TYPE_QUOTE } from 'utils/constants';
import { StyledButton } from 'components/Shared/StyledButton/StyledButton';
import { InputFieldType } from 'models/Input/InputModels';
import { useEffect, useMemo, useRef, useState } from 'react';
import { validate } from 'services/api/product-service';
import { Form, useNavigate } from 'react-router-dom';
import { LoadingSpinner } from 'components/Shared/Loading/LoadingSpinner/LoadingSpinner';
import { searchParamsHelper } from 'components/ProductBuild/searchParamsHelper';
import { getUTCDateData } from 'components/ProductBuild/helper';
import { useSnackbar } from 'context/snackbar/SnackBarProvider';
import styles from './ProductValidateSearchForm.module.scss';
export function ProductValidateSearchForm() {
    var _this = this;
    var navigate = useNavigate();
    var setSnackbarAlert = useSnackbar().setSnackbarAlert;
    var defErrorMessage = 'The string you entered is Either Incomplete or Formatted Incorrectly or Invalid';
    var _a = useState(false), isValidateError = _a[0], setIsValidateError = _a[1];
    var _b = useState(defErrorMessage), validateErrorMessage = _b[0], setValidateErrorMessage = _b[1];
    var _c = useState(false), isLoading = _c[0], setIsLoading = _c[1];
    var _d = useState(searchParamsHelper()), searchData = _d[0], setSearchData = _d[1];
    var productNbrInputRef = useRef(null);
    useEffect(function () {
        productNbrInputRef.current.focus();
    }, [productNbrInputRef]);
    useEffect(function () {
        var currentHour = new Date().getUTCHours();
        if (currentHour >= 0 && currentHour < 5) {
            var data_1 = __assign({}, searchData);
            var utcData = getUTCDateData(data_1.displayDate, data_1.displayTime);
            data_1.date = utcData.date;
            data_1.time = utcData.time;
            setSearchData(function () { return data_1; });
        }
    }, [searchData]);
    var handleSearchDataValueChange = function (field, val) {
        if (field === 'text' || field === 'rbv') {
            setIsValidateError(false);
        }
        var data = __assign({}, searchData);
        data[field] = val;
        if (field === 'date') {
            data.date = getUTCDateData(val, data.displayTime).date;
            data.displayDate = val;
        }
        else if (field === 'time') {
            var _a = getUTCDateData(data.displayDate, val), date = _a.date, time = _a.time;
            data.time = time;
            data.date = date;
            data.displayTime = val;
        }
        setSearchData(data);
    };
    var disableButton = useMemo(function () { return !searchData.text || !searchData.date || !searchData.time; }, [searchData]);
    var handleSearchButtonClick = function () { return __awaiter(_this, void 0, void 0, function () {
        var text, date, time, rbv, validateRsp, data, errorState_1, returnVal_1;
        var _a, _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    sessionStorage.removeItem('navigatedFrom');
                    sessionStorage.removeItem('parsedProductPayload');
                    setIsLoading(true);
                    text = searchData.text, date = searchData.date, time = searchData.time, rbv = searchData.rbv;
                    return [4 /*yield*/, validate({
                            productNbr: text,
                            requestType: REQUEST_TYPE_QUOTE,
                            returnNextFeature: false,
                            processingDate: "".concat(searchData.date, "T").concat(searchData.time, ".000Z"),
                        })];
                case 1:
                    validateRsp = _e.sent();
                    if (validateRsp.status >= 500) {
                        setSnackbarAlert({
                            message: 'Server Error - Please report the error to the PLS support board/help desk with details',
                            type: 'error',
                        });
                        setIsLoading(false);
                        return [2 /*return*/];
                    }
                    data = validateRsp.body;
                    if (validateRsp.status === 200 && data.completeProductInd) {
                        if (rbv === GSA_CHANNEL) {
                            if ((data === null || data === void 0 ? void 0 : data.gsaInd) !== 'Y') {
                                setIsValidateError(true);
                                setValidateErrorMessage('The string you entered is not valid for GSA');
                                (_a = productNbrInputRef === null || productNbrInputRef === void 0 ? void 0 : productNbrInputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
                                setIsLoading(false);
                                return [2 /*return*/];
                            }
                            setIsValidateError(false);
                            setValidateErrorMessage(defErrorMessage);
                        }
                        if (rbv === B2B_CHANNEL) {
                            if (data.b2bInd === 'Y') {
                                (_b = data.features) === null || _b === void 0 ? void 0 : _b.every(function (f) {
                                    var _a;
                                    if (f.type !== 'Derived' && f.type !== 'Implied') {
                                        if (f.b2bInd === 'N') {
                                            returnVal_1 = false;
                                            setIsValidateError(true);
                                            setValidateErrorMessage('The string you entered is not valid for B2B');
                                            (_a = productNbrInputRef === null || productNbrInputRef === void 0 ? void 0 : productNbrInputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
                                            errorState_1 = false;
                                            return false;
                                        }
                                        returnVal_1 = true;
                                        return true;
                                    }
                                    return true;
                                });
                                if (returnVal_1) {
                                    setIsValidateError(false);
                                    setValidateErrorMessage(defErrorMessage);
                                }
                                else {
                                    setIsValidateError(true);
                                    setIsLoading(false);
                                    return [2 /*return*/];
                                }
                            }
                            else {
                                errorState_1 = true;
                                setIsValidateError(true);
                                setValidateErrorMessage('The string you entered is not valid for B2B');
                                (_c = productNbrInputRef === null || productNbrInputRef === void 0 ? void 0 : productNbrInputRef.current) === null || _c === void 0 ? void 0 : _c.focus();
                            }
                        }
                        if (!isValidateError && !errorState_1) {
                            navigate("/product-validate/validate?productNbr=".concat(searchData.text, "&date=").concat(date, "&time=").concat(time, "&channel=").concat(rbv, "&pid=").concat(data.productId, "&productVersion=").concat(data.productVersion));
                        }
                        else {
                            setIsLoading(false);
                            setIsValidateError(true);
                        }
                    }
                    else {
                        setIsValidateError(true);
                        setValidateErrorMessage(defErrorMessage);
                        (_d = productNbrInputRef === null || productNbrInputRef === void 0 ? void 0 : productNbrInputRef.current) === null || _d === void 0 ? void 0 : _d.focus();
                        setIsLoading(false);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    return (_jsx(Form, { children: _jsxs(Box, __assign({ className: styles.container }, { children: [_jsx("h1", __assign({ className: styles.title }, { children: "Product Validate" })), _jsx("p", __assign({ className: styles.caption }, { children: "Review product-specific options, pricing, lead times, restrictions, and more. To begin, enter a complete product number in the search field. For historical product information, use a date relevant to your search." })), _jsx(Box, __assign({ className: styles.formContainer }, { children: _jsxs(Box, { children: [_jsx(PubInputField, { formInputRef: productNbrInputRef, fieldType: InputFieldType.STRING, labels: {
                                    left: 'Search by Complete Product Number',
                                    right: 'Required',
                                }, formInputName: "productNbr", fieldValue: searchData === null || searchData === void 0 ? void 0 : searchData.text, fieldValueUpdateHandler: function (e) { return handleSearchDataValueChange('text', e); }, fieldError: isValidateError, borderFocus: !!searchData.text && searchData.text !== '' }), isValidateError && (_jsx(Typography, __assign({ className: styles.errorMessage }, { children: validateErrorMessage }))), _jsxs(Box, __assign({ className: styles.dateAndTimeInputRow }, { children: [_jsx(Box, __assign({ className: styles.spaceBetweenInputs }, { children: _jsx(PubInputField, { fieldType: InputFieldType.DATE, labels: {
                                                left: 'Date',
                                                right: 'Required',
                                            }, formInputName: "date", fieldValue: searchData === null || searchData === void 0 ? void 0 : searchData.displayDate, fieldValueUpdateHandler: function (e) { return handleSearchDataValueChange('date', e); }, borderFocus: !!(searchData === null || searchData === void 0 ? void 0 : searchData.date) }) })), _jsx(Box, __assign({ className: styles.dateTimeFieldWidth }, { children: _jsx(PubInputField, { fieldType: InputFieldType.TIME, formInputName: "time", labels: {
                                                left: 'Time',
                                                right: 'Required',
                                            }, fieldValue: searchData === null || searchData === void 0 ? void 0 : searchData.displayTime, fieldValueUpdateHandler: function (e) { return handleSearchDataValueChange('time', e); }, fieldContainerWidthOverride: "100%", borderFocus: !!(searchData === null || searchData === void 0 ? void 0 : searchData.time) }) }))] })), _jsx(Box, __assign({ className: styles.radioBox }, { children: _jsx(PubInputField, { fieldType: InputFieldType.RADIO, fieldValue: searchData === null || searchData === void 0 ? void 0 : searchData.rbv, fieldValueUpdateHandler: function (e) { return handleSearchDataValueChange('rbv', e); }, labels: { left: 'Channel' }, fieldOptions: channelArray, fieldContainerWidthOverride: "fit-content" }) })), _jsx(Box, __assign({ className: styles.buttonBox }, { children: _jsx(StyledButton, { labelText: "Search", height: "47px", disabled: disableButton, buttonAction: function () { return handleSearchButtonClick(); }, width: "230px" }) }))] }) })), isLoading && (_jsx(Box, { children: _jsx(LoadingSpinner, { indicatorSize: 10 }) }))] })) }));
}
